// TxMonitoringForm.styles.ts
import { css } from '@emotion/css';

export const styles = {
  txMonitoringFormContainer: css({
    maxWidth: '1440px',
  }),

  forwardCultureHeading: css({
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '24px',
    marginTop: '5px !important',
  }),

  forwardCultureSubText: css({
    margin: '5px 0 15px 0 !important',
    color: '#708090',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
  }),

  unorderedListBlock: css({
    margin: '15px 0 0 15px',
    display: 'block',
  }),

  unorderedListBlockContactInformation: css({
    margin: '30px 0 0 15px',
    display: 'block',
  }),

  unorderedListContainer: css({
    fontSize: '16px',
    fontWeight: '400px',
    lineHeight: '24px',
  }),

  unorderedList: css({
    margin: '5px 0 0 -10px !important',
  }),

  headingMargin: css({
    marginTop: '10px !important',
  }),

  contactInformation: css({
    marginTop: '15px !important',
  }),

  contactInformationRow: css({
    display: 'block',
  }),

  contactInformationInputGroup: css({
    padding: '10px 0 20px 0',
    width: '265px',
    height: '58px',
    display: 'inline-flex',
    '& > fieldset': {
      minWidth: '165px',
    },
  }),

  verticalDropdown: css({
    width: '189px',
    marginTop: '20px',
  }),

  dropdownItemContainer: css({
    '& > div': {
      marginTop: '20px',
      minWidth: '250px !important',
      marginRight: '20px',
      '&:first-child': {
        display: 'none',
      },
    },
  }),

  radiodropdownParent: css({
    marginTop: '10px',
  }),

  title: css({
    marginTop: '10px',
    marginBottom: '5px',
  }),

  ccxDropdown: css({
    width: '189px',
    height: '58px',
    marginTop: '-5px',
  }),

  formTypeDropdown: css({
    width: '364px',
    height: '58px',
    marginTop: '-5px',
  }),

  resolveProblemDropdown: css({
    width: '364px',
    height: '58px',
    marginTop: '-5px',
  }),

  followPoliciesDropdown: css({
    width: '364px',
    height: '58px',
    marginTop: '-5px',
  }),

  formStepperContainer: css({
    display: 'inline-flex',
    width: '100%',
    marginTop: '35px !important',
    alignItems: 'start',
  }),

  leftCol: css({
    width: '300px',
    float: 'left',
  }),

  rightCol: css({
    marginLeft: '50px !important',
    width: '850px',
    height: '467',
    float: 'right',
    '& > div': {
      height: 'auto',
    },
  }),

  stepperBulletPoint: css({
    fontSize: '14px',
    listStyleType: 'disc !important',
  }),

  activeStepperLabel: css({
    fontWeight: 'bold',
    fontSize: '18px',
    marginLeft: '15px',
    lineHeight: '22px !important',
  }),

  stepperLabel: css({
    color: '#02080e',
  }),

  activeTenantHeading: css({
    fontWeight: 'bold',
    fontSize: '18px',
    marginLeft: '10px',
    marginTop: '5px',
    lineHeight: '22px',
  }),

  nextButtonContainer: css({
    width: '90.5%',
    margin: '18px 75px 25px 0',
    '& > *': {
      float: 'right',
    },
  }),

  backButtonContainer: css({
    width: '90.5%',
    margin: '18px 10px 0 0',
  }),

  noBulletPoint: css({
    listStyleType: 'none !important',
    fontSize: '14px',
  }),

  yesCheckGreen: css({
    color: 'green',
  }),

  noXRed: css({
    color: 'red',
  }),

  iconMargin: css({
    marginLeft: '-40px',
    marginRight: '20px',
  }),

  buttonsContainer: css({
    textAlign: 'end',
    width: '100%',
    marginTop: '50px',
  }),

  saveButton: css({
    margin: '0 10px',
  }),

  rightButtonsContainer: css({
    display: 'inline-flex',
    float: 'right',
  }),

  ulMarginAuto: css({
    marginLeft: 0,
    marginTop: 'auto',
    marginBottom: 'auto',
    marginRight: 0,
  }),

  bottomFormHeading: css({
    marginTop: '25px',
  }),

  emailCheckboxContainer: css({
    textAlign: 'end',
    paddingLeft: '10px',
    marginTop: '10px',
    '& > *': {
      display: 'unset !important',
    },
  }),

  playbackModalContainer: css({
    marginTop: '10px',
  }),

  contactSummary: css({
    marginTop: '20px',
  }),

  expert: css({
    color: '#003C52',
  }),

  intermediate: css({
    color: '#0085B3',
  }),

  novice: css({
    color: '#00A8E1',
  }),
};
